export default "__VITE_ASSET__409ab759__"